module.exports = __webpack_public_path__ + "media/images/category/dummy/tops02-4aa390c9009d74f1820c4a093f1a984d.jpg";